import { render, staticRenderFns } from "./F8822List.vue?vue&type=template&id=787f9dca&scoped=true&"
import script from "./F8822List.vue?vue&type=script&lang=ts&"
export * from "./F8822List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787f9dca",
  null
  
)

export default component.exports